/* global om */
import { Component } from 'react';
import uuidv1 from 'uuid/v1';
import SiteSettings from '~/siteSettings';
import { mobileCheck, verifyOm } from '~/utils/utils';

/**
 * Utag
 * @category Analytics
 * @extends Component
 * @summary Contains the UTAG data object.
 * @prop {string} pageType - The parent page type.
 * @prop {string} siteSection - The parent page section.
 * @prop {object} data - Object of additional data passed from parent (more than likely ENV values).
 * @return {Node} React node containing a window var which holds the UTAG data.
 */

class Utag extends Component {
  async componentDidMount() {
    const { pageType, siteSection, data } = this.props;

    // Define Global UTAG Data
    window.utag_data = {
      brandPlatformId: this.getBrandPlatformId(),
      deviceType: this.getDeviceType(),
      pageName: `${ SiteSettings.brand }:${ document.location.pathname }`,
      pageType,
      pageURL: document.location.href,
      pageViewGuid: uuidv1(),
      siteCode: SiteSettings.brand,
      siteSection,
      siteType: 'responsive web',
      userState: 'not authenticated',
      userType: 'anon',
      ...data
    };

    // verify Om object is present before tracking page.
    const isAnalyticsVerified = await verifyOm(100, 10);
    if (isAnalyticsVerified) {
      om.trackView();
    }
  }

  getBrandPlatformId() {
    return mobileCheck()
      ? `${ SiteSettings.brand }_site_mweb`
      : `${ SiteSettings.brand }_site_desktop`;
  }

  getDeviceType() {
    return mobileCheck()
      ? 'mobile'
      : 'desktop';
  }

  render() {
    return null;
  }
}

export default Utag;
